/** Custom events for imperative chat tab control (command palette, shortcuts). */

export const CHAT_NEW_TAB_EVENT = 'landi:chat-new-tab';
export const CHAT_NEXT_TAB_EVENT = 'landi:chat-next-tab';
export const CHAT_PREV_TAB_EVENT = 'landi:chat-prev-tab';
export const CHAT_CLOSE_TAB_EVENT = 'landi:chat-close-tab';
export const CHAT_FOCUS_INPUT_EVENT = 'landi:focus-chat-input';

export function dispatchChatNewTab(): void {
  window.dispatchEvent(new CustomEvent(CHAT_NEW_TAB_EVENT, { bubbles: true, composed: true }));
}

export function dispatchChatNextTab(): void {
  window.dispatchEvent(new CustomEvent(CHAT_NEXT_TAB_EVENT, { bubbles: true, composed: true }));
}

export function dispatchChatPrevTab(): void {
  window.dispatchEvent(new CustomEvent(CHAT_PREV_TAB_EVENT, { bubbles: true, composed: true }));
}

export function dispatchChatCloseTab(): void {
  window.dispatchEvent(new CustomEvent(CHAT_CLOSE_TAB_EVENT, { bubbles: true, composed: true }));
}

export function dispatchChatFocusInput(): void {
  window.dispatchEvent(new CustomEvent(CHAT_FOCUS_INPUT_EVENT, { bubbles: true, composed: true }));
}
